<template>

  <div class="py-10">
    <v-alert
      :value="alert_error"
      type="error"
      transition="scale-transition"
    >{{errorMessage}}</v-alert>
    <v-alert
      :value="alert_ok"
      type="success"
      transition="scale-transition"
    >{{okMessage}}</v-alert>
    <v-layout
      align-center
      justify-center
      class="pb-4"
    >

      <v-card
        elevation="2"
        class="mx-auto pb-4"
      >
        <v-card-title>Convertir Ticket en Factura </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row>

                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="this.$store.state.ticket.ticket"
                    label="Ticket"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="this.$store.state.ticket.fecha_ticket"
                    label="Fecha Emisión del Ticket"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="this.$store.state.ticket.punto_venta"
                    label="Punto de Venta"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="total"
                    label="Total"
                    readonly
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="rfc"
                    label="*RFC"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-text-field
                    v-model="razon_social"
                    label="*Razón Social"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-text-field
                    :rules="emailRules"
                    v-model="correo"
                    label="*Correo"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="domicilio_fiscal_receptor"
                    label="*Código Postal"
                    maxlength="5"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                >
                  <v-select
                    v-model="uso_cfdi"
                    :items="itemsUsoCFDI"
                    item-text="name"
                    item-value="codigo"
                    label="*Uso CFDI"
                    required
                  >
                  </v-select>
                </v-col>

                <v-col
                  cols="12"
                  md="5"
                >
                  <v-select
                    v-model="regimen_fiscal"
                    :items="itemsRegimenFiscal"
                    item-text="name"
                    item-value="codigo"
                    label="*Régimen Fiscal Receptor"
                    required
                  >
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Descripción
                          </th>
                          <th class="text-left">
                            Identificación
                          </th>
                          <th class="text-left">
                            Precio
                          </th>
                          <th class="text-left">
                            Cantidad
                          </th>
                          <th class="text-left">
                            Importe
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in conceptos"
                          :key="item.descripcion"
                        >
                          <td>{{ item.descripcion }}</td>
                          <td>{{ item.identificacion }}</td>
                          <td>{{ currencyFormat(item.precio) }}</td>
                          <td>{{ item.cantidad }}</td>
                          <td>{{ currencyFormat(item.importe) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  class="mb-4"
                >
                  <v-btn
                    :disabled="!showBtn"
                    color="primary"
                    @click="generarCFDI"
                  >Generar Factura</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { executeAction } from "../scripts/baseService.js";
import helpers from "../scripts/helpers.js";
export default {
  name: "generarCFDI",
  components: {},
  data() {
    return {
      valid: false,
      total: null,
      rfc: null,
      razon_social: null,
      correo: null,
      emailRules: [(v) => /.+@.+\..+/.test(v) || "Correo incorrecto"],
      uso_cfdi: null,
      regimen_fiscal: null,
      domicilio_fiscal_receptor: null,
      alert_error: false,
      errorMessage: "",
      okMessage: "",
      alert_ok: false,
      conceptos: [],
      itemsUsoCFDI: [
        {
          codigo: "G01",
          name: "G01 - Adquisición de mercancias",
        },
        {
          codigo: "G02",
          name: "G02 - Devoluciones, descuentos o bonificaciones",
        },
        {
          codigo: "G03",
          name: "G03 - Gastos en general",
        },
        {
          codigo: "I01",
          name: "I01 - Construcciones",
        },
        {
          codigo: "I02",
          name: "I02 - Mobilario y equipo de oficina por inversiones",
        },
        {
          codigo: "I03",
          name: "I03 - Equipo de transporte",
        },
        {
          codigo: "I04",
          name: "I04 - Equipo de computo y accesorios",
        },
        {
          codigo: "I05",
          name: "I05 - Dados, troqueles, moldes, matrices y herramental",
        },
        {
          codigo: "I06",
          name: "I06 - Comunicaciones telefónicas",
        },
        {
          codigo: "I07",
          name: "I07 - Comunicaciones satelitales",
        },
        {
          codigo: "I08",
          name: "I08 - Otra maquinaria y equipo",
        },
        {
          codigo: "D01",
          name: "D01 - Honorarios médicos, dentales y gastos hospitalarios.",
        },
        {
          codigo: "D02",
          name: "D02 - Gastos médicos por incapacidad o discapacidad",
        },
        {
          codigo: "D03",
          name: "D03 - Gastos funerales.",
        },
        {
          codigo: "D04",
          name: "D04 - Donativos.",
        },
        {
          codigo: "D05",
          name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).",
        },
        {
          codigo: "D06",
          name: "D06 - Aportaciones voluntarias al SAR.",
        },
        {
          codigo: "D07",
          name: "D07 - Primas por seguros de gastos médicos.",
        },
        {
          codigo: "D08",
          name: "D08 - Gastos de transportación escolar obligatoria.",
        },
        {
          codigo: "D09",
          name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.",
        },
        {
          codigo: "D10",
          name: "D10 - Pagos por servicios educativos (colegiaturas)",
        },
        {
          codigo: "P01",
          name: "P01 - Por definir",
        },
        {
          codigo: "S01",
          name: "S01 - Sin efectos fiscales",
        },
      ],
      itemsRegimenFiscal: [
        { codigo: "601", name: "601 - General de Ley Personas Morales" },
        {
          codigo: "603",
          name: "603 - Personas Morales con Fines no Lucrativos",
        },
        {
          codigo: "605",
          name: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
        },
        { codigo: "606", name: "606 - Arrendamiento" },
        {
          codigo: "607",
          name: "607 - Régimen de Enajenación o Adquisición de Bienes",
        },
        { codigo: "608", name: "608 - Demás ingresos" },
        {
          codigo: "610",
          name: "610 - Residentes en el Extranjero sin Establecimiento Permanente en México",
        },
        {
          codigo: "611",
          name: "611 - Ingresos por Dividendos (socios y accionistas)",
        },
        {
          codigo: "612",
          name: "612 - Personas Físicas con Actividades Empresariales y Profesionales",
        },
        { codigo: "614", name: "614 - Ingresos por intereses" },
        {
          codigo: "615",
          name: "615 - Régimen de los ingresos por obtención de premios",
        },
        { codigo: "616", name: "616 - Sin obligaciones fiscales" },
        {
          codigo: "620",
          name: "620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
        },
        { codigo: "621", name: "621 - Incorporación Fiscal" },
        {
          codigo: "622",
          name: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
        },
        { codigo: "623", name: "623 - Opcional para Grupos de Sociedades" },
        { codigo: "624", name: "624 - Coordinados" },
        {
          codigo: "625",
          name: "625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
        },
        { codigo: "626", name: "626 - Régimen Simplificado de Confianza" },
      ],
    };
  },
  methods: {
    currencyFormat(value) {
      return helpers.currencyFormat(value);
    },

    async generarCFDI() {
      let jsonRequest = {
        ticket: this.$store.state.ticket.ticket,
        fecha_ticket: this.$store.state.ticket.fecha_ticket.substring(0, 10),
        total: this.$store.state.ticket.total,
        correo: this.correo,
        rfc: this.rfc,
        razon_social: this.razon_social,
        direccion_fiscal: null,
        uso_cfdi: this.uso_cfdi,
        regimen_fiscal: this.regimen_fiscal,
        domicilio_fiscal_receptor: this.domicilio_fiscal_receptor,
        forma_pago: this.$store.state.ticket.forma_pago,
      };
      await executeAction("POST", "CFDI/Generate", jsonRequest, false).then(
        (response) => {
          this.$store.commit("setOverlay", false);
          if (!response.result) {
            this.alert_error = true;
            this.errorMessage = response.errorMessage;
            setTimeout(() => {
              this.alert_error = false;
              this.errorMessage = "";
            }, 5000);
          } else {
            this.$store.commit("setIssue", false);
            this.$store.commit("setIsNew", true);
            this.$router.push({
              path: "/obtenerDocs",
            });
          }
        }
      );
    },
  },
  computed: {
    showBtn() {
      return (
        this.$store.state.ticket != null &&
        this.rfc &&
        this.razon_social &&
        this.correo &&
        this.uso_cfdi &&
        this.domicilio_fiscal_receptor &&
        this.regimen_fiscal &&
        this.valid
      );
    },
  },
  mounted() {},
  created() {
    this.$store.commit("setIssue", true);
    this.total = this.currencyFormat(this.$store.state.ticket.total);
    this.conceptos = this.$store.state.ticket.conceptos;
  },
};
</script>

<style>
</style>
